import { Component, OnInit, Inject, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../core/services/auth.service';

declare let require: any;

@Component({
  selector: 'ng-password',
  template: require('./ng-password.component.html').default,
  styles: [require('!!raw-loader!sass-loader!./ng-password.component.scss').default],
  standalone: false,
})
export class NgPasswordComponent implements OnInit {
  message: string = 'Byt lösenord';
  userName: string = '';

  user: any = {
    currPwd: '',
    newPwd: '',
    newPwdAgain: '',
  };

  showCurrPwd = false;
  showNewPwd = false;
  showNewPwdAgain = false;

  successMessage: string | null = null;
  errorMessage: string | null = null;

  private destroyRef = inject(DestroyRef);

  constructor(@Inject(AuthService) private authService: AuthService) {}

  toggleVisibility(field: 'curr' | 'new' | 'newAgain'): void {
    if (field === 'curr') this.showCurrPwd = !this.showCurrPwd;
    if (field === 'new') this.showNewPwd = !this.showNewPwd;
    if (field === 'newAgain') this.showNewPwdAgain = !this.showNewPwdAgain;
  }

  ngOnInit(): void {
    this.authService.getUser().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data) => {
        this.userName = data.username;
      },
      (error) => {
        console.error('Error fetching user', error);
      }
    );
  }

  handlePwdChange(event: Event): void {
    event.preventDefault();

    if (this.userName && this.user.currPwd) {
      const payload = {
        username: this.userName,
        oldPassword: this.user.currPwd,
        newPassword: this.user.newPwd,
      };

      this.authService.changePassword(payload).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        (success) => {
          if (success.res !== 'ok') {
            this.errorMessage = success.res;
            this.successMessage = null;
          } else {
            this.errorMessage = null;
            this.successMessage = 'ok';
            // Reset form fields
            this.user.currPwd = '';
            this.user.newPwd = '';
            this.user.newPwdAgain = '';
          }
        },
        (error) => {
          this.errorMessage = error.statusText || 'An error occurred';
          this.successMessage = null;
        }
      );
    }
  }
}
